import clsx from 'clsx';
import React from 'react';
import { tableActionContainerStyles } from './tableActionContainerStyles';

const TableActionContainer = ({ children, style, onTour }) => {
  const styles = tableActionContainerStyles();
  return (
    <div
      onClick={(e) => {}}
      style={style}
      className={clsx(styles.container, !onTour && 'table-action-container')}
    >
      {children}
    </div>
  );
};

export default TableActionContainer;
